import { t } from 'i18next';
import { OptionI } from '../../types/interface';
import { capitalizeFirstLetter } from './helpers';
import {
  AccountType,
  ACTIVE,
  APPROVED,
  ARCHIVE,
  CARINTHIA,
  CUSTOM_REFUNDABLE,
  EARLY_RETIREMENT,
  EDUCATION,
  HEALTH,
  HEALTH_ENUM,
  INTERNAL_EMPLOYEE,
  LEASING_AND_PAYROLLING,
  NOT_REFUNDABLE,
  PENDING,
  REFUNDABLE,
  REJECTED,
  RefundPolicy,
  SALZBURG,
  SAP_AGREE,
  SAP_DISAGREE,
  SCHOOL_ACTIVITY_OF_CHILD_ENUM,
  STYRIA,
  TYROL,
  UPPER_AUSTRIA,
  VORARLBERG,
  VPA_OST_1,
  VPA_OST_2,
  VPA_OST_3,
  WITHOUT_INCOME,
  WITH_INCOME
} from './enums/misc';
import { TabItems } from 'base/StandardTab/tabInterface';
import { faHistory, faUser } from '@fortawesome/free-solid-svg-icons';

export const userTypeOption = [
  {
    label: t('register_applicant.radioButtons1.label_1'),
    value: 'active_employee'
  },
  {
    label: t('user.option.label_2'),
    value: 'early_retirement'
  }
];

export const user_type: OptionI[] = [
  {
    label: capitalizeFirstLetter(t('register_applicant.radioButtons1.label_2')),
    value: INTERNAL_EMPLOYEE
  },
  {
    label: capitalizeFirstLetter(t('user.option.label_2')),
    value: EARLY_RETIREMENT
  },
  {
    label: capitalizeFirstLetter(t('register_applicant.radioButtons2.label_1')),
    value: LEASING_AND_PAYROLLING
  }
];

export const archiveSearchOptions = [
  {
    value: ARCHIVE,
    label: capitalizeFirstLetter(t('common_table.text_5'))
  },
  {
    value: ACTIVE,
    label: capitalizeFirstLetter(t('common_table.text_4'))
  }
];

export const userTypeOptions: OptionI[] = [
  {
    label: capitalizeFirstLetter(t('user.user_type.label_1')),
    value: 'admin'
  },
  {
    label: capitalizeFirstLetter(t('header.text.text_2')),
    value: 'user'
  }
];

export const federal_state: OptionI[] = [
  {
    label: t('register_applicant.dropdown.option_1'),
    value: VPA_OST_3.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_2'),
    value: VPA_OST_2.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_3'),
    value: VPA_OST_1.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_4'),
    value: UPPER_AUSTRIA.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_5'),
    value: SALZBURG.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_6'),
    value: TYROL.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_7'),
    value: STYRIA.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_8'),
    value: CARINTHIA.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_9'),
    value: VORARLBERG.toLowerCase()
  }
];

export const sap_agree_radio: OptionI[] = [
  {
    label: t('register_applicant.radioButtons4.label_1'),
    value: SAP_AGREE
  },
  {
    label: t('register_applicant.radioButtons5.label_1'),
    value: SAP_DISAGREE
  }
];

export const basicDataOptions: OptionI[] = [
  {
    label: t('header.text.text_10'),
    value: WITH_INCOME
  },
  {
    label: t('header.text.text_11'),
    value: WITHOUT_INCOME
  }
];

export const statusOptions: OptionI[] = [
  {
    label: t('applications.status.text_1'),
    value: APPROVED
  },
  {
    label: t('applications.status.text_2'),
    value: REJECTED
  },
  {
    label: t('applications.status.text_3'),
    value: PENDING
  }
];

export const debounceTime: number = 1000;

export const dataPerPageSelectOptions: number[] = [10, 20, 50, 100];

export const ApplicationTypes: OptionI[] = [
  {
    label: t('applications.application_type.text_1'),
    value: HEALTH_ENUM
  },
  {
    label: t('applications.application_type.text_2'),
    value: SCHOOL_ACTIVITY_OF_CHILD_ENUM
  }
];

export const refundOptions = [
  {
    label: t('product_form.placeholder.text_3'),
    value: RefundPolicy.FULL_OPTIONAL_SV
  },
  {
    label: t('product_form.placeholder.text_7'),
    value: RefundPolicy.CONDITIONAL_SV_ZERO_ALLOWED
  },
  {
    label: t('product_form.placeholder.text_13'),
    value: RefundPolicy.CONDITIONAL_SV_REQUIRED_POSITIVE
  },
  {
    label: t('product_form.placeholder.text_12'),
    value: RefundPolicy.NON_REFUNDABLE
  }
];

export const tabData: TabItems[] = [
  {
    activeId: 'form',
    icon: faUser,
    label: t('user.button.text_4')
  },
  {
    activeId: 'logs',
    icon: faHistory,
    label: t('user.button.text_5')
  }
];

export const accountTypeTabs: TabItems[] = [
  {
    activeId: AccountType.ADMIN,
    icon: faUser,
    label: t('user.account_type.admin')
  },
  {
    activeId: AccountType.USER,
    icon: faUser,
    label: t('user.account_type.user')
  }
];

type colorType = `#${string}`;

export const AVATAR_COLORS: { bg: colorType; text: colorType }[] = [
  { bg: '#e8eaf6', text: '#5c6bc0' },
  { bg: '#e8f5e9', text: '#43a047' },
  { bg: '#fce4ec', text: '#e57373' },
  { bg: '#eeeeee', text: '#757575' },
  { bg: '#e3f2fd', text: '#42a5f5' },
  { bg: '#f3e5f5', text: '#ab47bc' },
  { bg: '#fff8e1', text: '#ffb300' },
  { bg: '#e0f2f1', text: '#26a69a' }
];

export const applicationFieldMap = {
  // from educationApplicationFieldMap
  child: 'application.education.placeholder.text_7',
  organizer: 'general.input_fields.text_30',
  event_name: 'event.table.title_2',
  event: 'application.education.placeholder.text_6',
  event_start_date: 'application.education.placeholder.text_10',
  event_end_date: 'application.education.placeholder.text_11',
  filled_out_template: 'application.education.placeholder.text_12',
  filled_out_template_amount: 'application.education.placeholder.text_13',
  filled_out_template_date_proof: 'basic_data.with_income.placeholder.text_4',
  confirmation_of_participation: 'application.education.attachment.text_1',
  confirmation_of_participation_date_proof:
    'basic_data.with_income.placeholder.text_4',
  invoice: 'application.education.attachment.text_4',
  invoice_amount: 'application.education.placeholder.text_14',
  invoice_date_proof: 'basic_data.with_income.placeholder.text_4',
  payment_confirmation: 'application.general.text_27',
  payment_confirmation_amount: 'application.education.placeholder.text_15',
  payment_confirmation_date_proof: 'basic_data.with_income.placeholder.text_4',

  // from healthApplicationFieldMap (invoice & payment_confirmation already defined above)
  option: 'overview.health_application.table_header.text_10',
  bill_recipient_name: 'overview.health_application.table_header.text_1',
  invoice_issuer: 'overview.health_application.table_header.text_2',
  bill_number: 'overview.health_application.table_header.text_3',
  total_invoice: 'overview.health_application.table_header.text_4',
  date_invoice: 'overview.health_application.table_header.text_5',
  paid_date: 'application.input.input_4',
  restoration_svt_to_eur: 'application.input.input_5',
  social_security_provider_refund_date: 'application.input.input_16',
  social_security_provider_refund: 'application.general.text_3',
  restoration_insurance: 'application.input.input_6',
  other_funds_date: 'application.input.input_17',
  other_funds: 'application.general.text_4',
  product_name: 'application.placeholder.product_option',
  product_amount_net: 'application.input.input_12',
  service_name_on_invoice: 'application.input.input_11',
  refund_policy: 'application.input.input_3',

  // from withoutIncomeChildrenFieldMap
  first_name: 'general.common_text.text_5',
  last_name: 'general.common_text.text_6',
  birth_date: 'register_applicant.placeholder.birthDate',
  street: 'register_applicant.placeholder.street',
  zip_code: 'basic_data.without_income.left.placeholder.PLZ(Private)',
  location: 'basic_data.without_income.left.placeholder.Ort (Privat)',
  birth_certificate_file: 'basic_data.without_income.right.attachment.text_2',
  registration_form_file: 'basic_data.without_income.left.attachment.text_1',
  family_benefits_file: 'basic_data.with_income.placeholder.text_28',
  family_benefits_date_proof: 'basic_data.with_income.placeholder.text_27',

  // from withoutIncomeFamilyFieldMap (all keys already defined above)

  // from withIncomeChildrenFieldMap (first_name, last_name, birth_date, birth_certificate_file,
  // family_benefits_file, family_benefits_date_proof, street, zip_code, location,
  // registration_form_file already defined above)
  school_study_confirmation_file: 'basic_data.with_income.attachment.text_17',
  school_study_confirmation_date_proof:
    'basic_data.with_income.placeholder.text_4',
  confirmation_of_co_insurance_file:
    'basic_data.with_income.attachment.text_16',
  confirmation_of_co_insurance_date_proof:
    'basic_data.with_income.placeholder.text_4',
  basic_military_community_service_file:
    'basic_data.with_income.attachment.text_14',
  basic_military_community_service_date_proof:
    'basic_data.with_income.placeholder.text_4',
  net_income_eur: 'subsidy_calculation_with.message.value_3',
  proof_of_income_file: 'basic_data.with_income.attachment.text_13',
  proof_of_income_date_proof: 'basic_data.with_income.placeholder.text_4',

  // from withIncomeFamilyFieldMap (first_name, last_name, birth_date, street, zip_code, location,
  // registration_form_file, net_income_eur, confirmation_of_co_insurance_file,
  // confirmation_of_co_insurance_date_proof already defined above)
  pay_slip_file: 'basic_data.with_income.attachment.text_2',
  pay_slip_date_proof: 'basic_data.with_income.placeholder.text_4',
  pension_notice_file: 'basic_data.with_income.attachment.text_3',
  pension_notice_date_proof: 'basic_data.with_income.placeholder.text_4',
  additional_income_eur: 'basic_data.with_income.placeholder.text_11',
  proof_of_income_or_income_tax_notice_file:
    'basic_data.with_income.attachment.text_5',
  proof_of_income_or_income_tax_notice_date_proof:
    'basic_data.with_income.placeholder.text_4',
  childcare_allowance_eur: 'basic_data.with_income.placeholder.text_12',
  proof_of_child_allowance_file: 'basic_data.with_income.attachment.text_6',
  proof_of_child_allowance_date_proof:
    'basic_data.with_income.placeholder.text_4',
  family_bonus_eur: 'basic_data.with_income.placeholder.text_13',
  family_bonus_file: 'basic_data.without_income.left.attachment.text_3',
  family_bonus_date_proof: 'basic_data.with_income.placeholder.text_4',
  alimony_amount: 'basic_data.with_income.placeholder.text_14',
  paid: 'basic_data.with_income.checkbox.text_4',
  received: 'basic_data.with_income.checkbox.text_3',
  alimentation_payment_file: 'basic_data.with_income.attachment.text_7',
  alimentation_payment_date_proof: 'basic_data.with_income.placeholder.text_4',
  alimentation_payment_file_1: 'basic_data.with_income.attachment.text_30',
  alimentation_payment_date_proof_1:
    'basic_data.with_income.placeholder.text_4',
  alimentation_payment_file_2: 'basic_data.with_income.attachment.text_31',
  alimentation_payment_date_proof_2:
    'basic_data.with_income.placeholder.text_4',
  decision_file: 'basic_data.with_income.attachment.text_8',
  decision_date_proof: 'basic_data.with_income.placeholder.text_4',

  // application activity log fields
  total_household_income_per_person:
    'household_income_calculator.calculator.result.field_2',
  family_members: 'household_income_calculator.calculator.members.title',
  children: 'basic_data.with_income.general.text_4'
};
